import type { GatsbyBrowser } from "gatsby";

import { htmlLang } from "./src/components/Seo/locales";

// onRenderBody only runs at build time, so <html lang> would go stale as soon
// as the user navigates client-side or switches language.
export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  document.documentElement.lang = htmlLang(location.pathname);
};
// import {
//   ApolloClient,
//   ApolloProvider,
//   HttpLink,
//   InMemoryCache,
// } from "@apollo/client";
// import fetch from "isomorphic-fetch";

// const cfcuEnvVars = ["cfcu", "cfcu-prod"];
// const isCfcu = cfcuEnvVars?.includes(process.env.GATSBY_APP_TYPE as string);

// const httpLink = new HttpLink({
//   uri: isCfcu
//     ? `http://159.69.149.136:8082/graphql`
//     : "http://159.69.149.136:8082/graphql",
//   fetch,
// });

// const apolloClient = new ApolloClient({
//   link: httpLink,
//   cache: new InMemoryCache(),
// });
// import { Layout } from "./src/components/Layout/Layout";
// export const wrapPageElement = ({ element, props }) => (
//   <Layout crumbs={[]}>{element}</Layout>
// );

// const wrapRootElement = ({ element }) => (
//   <ApolloProvider client={apolloClient}>{element}</ApolloProvider>
// );

// export { wrapPageElement, wrapRootElement };
